<template>
  <div class="urgent-purchase-container">
    <ds-page-header :title="$t('urgentPurchaseApplyStep.page.title')" :subtitle="$t('urgentPurchaseApplyStep.page.subtitle')">
      <template #extra>
        <el-button type="primary" size="small" icon="el-icon-check" @click="_finishStep">
          {{ $t('urgentPurchaseApplyStep.submit') }}
        </el-button>
      </template>
    </ds-page-header>

    <div class="ds-panel ds-panel--padded">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('urgentPurchaseApplyStep.applyInfo') }}</span>
      </div>
      <el-form label-width="120px">
        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item :label="$t('urgentPurchaseApplyStep.warehouse')">
              <el-select v-model="urgentPurchaseApplyStepInfo.shId" @change="_computeFlow" style="width:100%" clearable
                :placeholder="$t('urgentPurchaseApplyStep.requiredSelectWarehouse')">
                <el-option disabled value="" :label="$t('urgentPurchaseApplyStep.requiredSelectWarehouse')" />
                <el-option v-for="(item, index) in urgentPurchaseApplyStepInfo.storehouses" :key="index" :label="item.shName" :value="item.shId" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item :label="$t('urgentPurchaseApplyStep.contact')">
              <el-input v-model.trim="urgentPurchaseApplyStepInfo.endUserName" :placeholder="$t('urgentPurchaseApplyStep.requiredContact')" clearable />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item :label="$t('urgentPurchaseApplyStep.phone')">
              <el-input v-model.trim="urgentPurchaseApplyStepInfo.endUserTel" :placeholder="$t('urgentPurchaseApplyStep.requiredPhone')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('urgentPurchaseApplyStep.applyDesc')">
              <el-input type="textarea" :rows="2" v-model.trim="urgentPurchaseApplyStepInfo.description" :placeholder="$t('urgentPurchaseApplyStep.requiredDesc')" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="ds-panel">
      <ds-toolbar :show-column-setting="false" :show-density="false" :show-refresh="false">
        <template #left>
          <span class="ds-panel__title">{{ $t('urgentPurchaseApplyStep.purchaseItems') }}</span>
        </template>
        <template #right>
          <el-button type="primary" size="small" icon="el-icon-plus" @click="_openSelectResourceStoreInfoModel">
            {{ $t('urgentPurchaseApplyStep.select') }}
          </el-button>
        </template>
      </ds-toolbar>
      <ds-data-table :data="urgentPurchaseApplyStepInfo.resourceStores" border
        :empty-description="$t('urgentPurchaseApplyStep.page.empty')">
        <el-table-column :label="$t('urgentPurchaseApplyStep.itemType')" align="center" min-width="140">
          <template slot-scope="scope">
            {{ scope.row.parentRstName || '-' }} &gt; {{ scope.row.rstName || '-' }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('urgentPurchaseApplyStep.nameCode')" align="center" min-width="160">
          <template slot-scope="scope">
            {{ scope.row.resName }}({{ scope.row.resCode }})
          </template>
        </el-table-column>
        <el-table-column :label="$t('urgentPurchaseApplyStep.spec')" align="center" width="110">
          <template slot-scope="scope">
            {{ scope.row.rssName || '-' }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('urgentPurchaseApplyStep.referencePrice')" align="center" width="110">
          <template slot-scope="scope">
            <span class="ds-num">{{ scope.row.price || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('urgentPurchaseApplyStep.stock')" align="center" width="110">
          <template slot-scope="scope">
            <span class="ds-num">{{ scope.row.stock }}{{ scope.row.unitCodeName }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('urgentPurchaseApplyStep.applyQuantity')" align="center" min-width="150">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.quantity" :min="1"
              :placeholder="$t('urgentPurchaseApplyStep.requiredQuantity')" style="width: 100px" controls-position="right" />
            {{ scope.row.unitCodeName }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('urgentPurchaseApplyStep.purchasePrice')" align="center" min-width="150">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.urgentPrice" :min="0.01"
              :placeholder="$t('urgentPurchaseApplyStep.requiredPrice')" style="width: 110px" controls-position="right" />
          </template>
        </el-table-column>
        <el-table-column :label="$t('urgentPurchaseApplyStep.targetWarehouse')" align="center" min-width="150">
          <template slot-scope="scope">
            <el-select v-model="scope.row.shzId" @change="storeHousesChange($event, scope.$index)" style="width:100%"
              :placeholder="$t('urgentPurchaseApplyStep.requiredTargetWarehouse')">
              <el-option value="" :label="$t('urgentPurchaseApplyStep.requiredTargetWarehouse')" />
              <el-option v-for="(storehouse, storeIndex) in urgentPurchaseApplyStepInfo.storehousesB" :key="storeIndex"
                :value="storehouse.shId" :label="storehouse.shName" />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column :label="$t('urgentPurchaseApplyStep.remark')" align="center" min-width="140">
          <template slot-scope="scope">
            <el-input v-model="scope.row.remark" :placeholder="$t('urgentPurchaseApplyStep.optionalRemark')" clearable />
          </template>
        </el-table-column>
        <el-table-column :label="$t('urgentPurchaseApplyStep.operation')" align="center" width="90" fixed="right">
          <template slot-scope="scope">
            <el-button type="danger" size="mini" @click="_removeSelectResourceStoreItem(scope.row.resId)">
              {{ $t('urgentPurchaseApplyStep.remove') }}
            </el-button>
          </template>
        </el-table-column>
      </ds-data-table>
    </div>

    <choose-resource-store4 ref="chooseResourceStore4" @setSelectResourceStores="handleSetSelectResourceStores" />
  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import ChooseResourceStore4 from '@/components/resource/chooseResourceStore4'
import * as api from '@/api/resource/urgentPurchaseApplyStepApi'
import { getUserName, getUserTel } from '@/api/user/userApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsToolbar from '@/components/ds/ds-toolbar.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'

export default {
  name: 'UrgentPurchaseApplyStepList',
  components: { ChooseResourceStore4, DsPageHeader, DsToolbar, DsDataTable },
  data() {
    return {
      urgentPurchaseApplyStepInfo: {
        resourceStores: [], description: '', endUserName: '', endUserTel: '',
        file: '', resOrderType: '', staffId: '', shId: '', staffName: '',
        communityId: '', storehouses: [], storehousesB: []
      }
    }
  },
  created() {
    this._initData()
  },
  methods: {
    async _initData() {
      this.urgentPurchaseApplyStepInfo.communityId = await getCommunityId()
      this.urgentPurchaseApplyStepInfo.resOrderType = this.$route.query.resOrderType
      this.urgentPurchaseApplyStepInfo.endUserName = getUserName()
      this.urgentPurchaseApplyStepInfo.endUserTel = getUserTel()
      this._listAllocationStorehouse()
      this._listAllocationStorehouseB()
    },
    async _listAllocationStorehouse() {
      try {
        const params = { page: 1, row: 100, allowPurchase: 'ON' }
        const { data } = await api.listStorehouses(params)
        this.urgentPurchaseApplyStepInfo.storehouses = data
      } catch (error) { console.error('获取仓库列表失败:', error) }
    },
    async _listAllocationStorehouseB() {
      try {
        const params = { page: 1, row: 100, communityId: this.urgentPurchaseApplyStepInfo.communityId }
        const { data } = await api.listStorehouses(params)
        this.urgentPurchaseApplyStepInfo.storehousesB = data
      } catch (error) { console.error('获取目标仓库列表失败:', error) }
    },
    _openSelectResourceStoreInfoModel() {
      if (!this.urgentPurchaseApplyStepInfo.shId) {
        this.$message.error(this.$t('urgentPurchaseApplyStep.requiredSelectWarehouse'))
        return
      }
      if (!this.urgentPurchaseApplyStepInfo.endUserName) {
        this.$message.error(this.$t('urgentPurchaseApplyStep.requiredContact'))
        return
      }
      if (!this.urgentPurchaseApplyStepInfo.endUserTel) {
        this.$message.error(this.$t('urgentPurchaseApplyStep.requiredPhone'))
        return
      }
      if (!this.urgentPurchaseApplyStepInfo.description) {
        this.$message.error(this.$t('urgentPurchaseApplyStep.requiredDesc'))
        return
      }
      this.$refs.chooseResourceStore4.open({ shId: this.urgentPurchaseApplyStepInfo.shId })
    },
    handleSetSelectResourceStores(resourceStores) {
      let oldList = this.urgentPurchaseApplyStepInfo.resourceStores
      resourceStores.forEach((newItem, newIndex) => {
        newItem.rsId = ''
        newItem.shzId = ''
        oldList.forEach((oldItem) => {
          if (oldItem.resId === newItem.resId) delete resourceStores[newIndex]
        })
      })
      resourceStores.push.apply(resourceStores, oldList)
      resourceStores = resourceStores.filter((s) => { return s['resId'] })
      this.urgentPurchaseApplyStepInfo.resourceStores = resourceStores
    },
    _resourcesFromSameHouse(resourcesList) {
      if (!resourcesList || resourcesList.length < 2) return true
      let lastHouse = ''
      for (let i = 0; i < resourcesList.length; i++) {
        if (lastHouse === '') { lastHouse = resourcesList[i].shId; continue }
        if (lastHouse === resourcesList[i].shId) continue
        else return false
      }
      return true
    },
    async _finishStep() {
      const _resourceStores = this.urgentPurchaseApplyStepInfo.resourceStores
      if (!_resourceStores || _resourceStores.length < 1) {
        this.$message.error(this.$t('urgentPurchaseApplyStep.requiredSelectItems'))
        return
      }
      if (!this._resourcesFromSameHouse(_resourceStores)) {
        this.$message.error(this.$t('urgentPurchaseApplyStep.sameWarehouseRequired'))
        return
      }
      let _saveFlag = true
      _resourceStores.forEach(item => {
        if (!item.shzId) {
          this.$message.error(`${item.resName}${this.$t('urgentPurchaseApplyStep.requiredTargetWarehouse')}`)
          _saveFlag = false
          return
        }
        if (!item.quantity || item.quantity <= 0) {
          this.$message.error(`${item.resName}${this.$t('urgentPurchaseApplyStep.requiredQuantity')}`)
          _saveFlag = false
          return
        }
        if (!item.urgentPrice || item.urgentPrice <= 0) {
          this.$message.error(`${item.resName}${this.$t('urgentPurchaseApplyStep.requiredPrice')}`)
          _saveFlag = false
          return
        }
      })
      if (!_saveFlag) return
      try {
        const res = await api.urgentPurchaseApply(this.urgentPurchaseApplyStepInfo)
        if (res.code === 0) { this.$message.success(this.$t('common.operationSuccess')); this.$router.go(-1) }
        else this.$message.error(res.msg)
      } catch (error) {
        console.error('提交失败:', error)
        this.$message.error(this.$t('common.operationFailed'))
      }
    },
    storeHousesChange(e, i) {
      const shId = e
      this.urgentPurchaseApplyStepInfo.storehouses.forEach((item) => {
        if (item.shId === shId) this.urgentPurchaseApplyStepInfo.resourceStores[i].shzName = item.shName
      })
    },
    _removeSelectResourceStoreItem(resId) {
      this.urgentPurchaseApplyStepInfo.resourceStores.forEach((item, index) => {
        if (item.resId === resId) this.urgentPurchaseApplyStepInfo.resourceStores.splice(index, 1)
      })
    },
    _computeFlow() {
      this.urgentPurchaseApplyStepInfo.resourceStores = []
    }
  }
}
</script>

<style lang="scss" scoped>
.urgent-purchase-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}
.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
  margin-bottom: var(--ds-spacing-lg);
  &--padded { padding: var(--ds-spacing-lg); }
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: var(--ds-spacing-md);
    margin-bottom: var(--ds-spacing-md);
    border-bottom: 1px solid var(--ds-gray-200);
  }
  &__title {
    font-size: var(--ds-font-size-lg);
    font-weight: 600;
    color: var(--ds-gray-800);
  }
}
</style>
